<div [hidden]="mode === 'hidden'">
  @if (loading$ | async) {
    <loading-overlay class="add-ons-overlay"></loading-overlay>
  }
  @if (showOIDCIframe) {
    <iframe #Oidc id="Oidc" aria-hidden="true" title="Commerce iframe"></iframe>
  }
  <div [ngClass]="{'hide-footer-navigation': hideFooterNavigation}">
    <router-outlet name="commerceElement"></router-outlet>
  </div>
</div>
